<template>
  <v-container>
    <v-card raised elevation="24">
      <v-card-title>
        <p class="text-uppercase text-center">PROFILE</p>
      </v-card-title>
      <v-card-text>
        <div>
          <v-row>
            <v-col>Name :</v-col>
            <v-col>{{ userinfo.name }}</v-col>
          </v-row>
          <v-row>
            <v-col>USER ID :</v-col>
            <v-col>{{ userinfo.userid }}</v-col>
          </v-row>
          <v-row>
            <v-col>ROLE :</v-col>
            <v-col>{{ userinfo.role }}</v-col>
          </v-row>
          <v-row>
            <v-col>Contact Number :</v-col>
            <v-col>{{ userinfo.phone }}</v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn block color="primary1" dark @click="box=true">change password</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="box" persistent scrollable max-width="50%">
      <v-card>
        <v-card-title>
          <span class="headline">EDIT PRODUCT</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            :type="show ? 'text' : 'password'"
            :append-icon="show ? 'mdi-eye-outline':'mdi-eye-off'"
            @click:append="show = !show"
            label="User Password"
            prepend-inner-icon="mdi-lock"
            v-model="password"
            :rules="[RULES.required]"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn color="error" block @click="box = false">Close</v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary1" block dark @click="changePassword">UPDATE</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      box: false,
      password: "",
      show: false,
      userinfo: {}
    };
  },
  created() {
    this.userinfo = this.$session.get("userinfo");
  },
  computed: {
    ...mapGetters(["RULES"])
  },
  methods: {
    ...mapActions(["CHANGE_PASSWORD", "LOGOUT"]),
    changePassword() {
      this.$store.commit("SET_LOADING", true);
      this.CHANGE_PASSWORD({
        id: this.userinfo.id,
        password: this.password
      }).then(() => {
        this.password = "";
        this.box = false;
        this.LOGOUT().then(() => {
          this.$router.replace("/");
          this.$store.commit("SET_LOADING", false);
        });
      });
    }
  }
};
</script>

<style></style>
